// Costume configuration
import { CostumeId } from '../types';

export const COSTUME_DATA: Record<CostumeId, { label: string, price: number, description: string }> = {
    'DEFAULT': { label: 'Stage Outfit', price: 0, description: 'Standard performance gear.' },
    'PAJAMAS': { label: 'Animal Pajamas', price: 1000, description: 'Cute onesies. "Comfy but unprofessional."' },
    'LEATHER': { label: 'Tactical Leather', price: 5000, description: 'Squeaky black suits. "The leather has betrayed us!"' },
    'HANBOK': { label: 'Modern Hanbok', price: 20000, description: 'Ancestral threads for the final battle.' }
};
